import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ClientsService } from '@core/services/clients/clients.service';
import { ClientConfigService } from '../client-config/client-config.service';

export const clientSetupResolver: ResolveFn<boolean> = (route, _state) => {
  const _clientsService = inject(ClientsService);
  const clientConfigService = inject(ClientConfigService);
  const router = inject(Router);
  const slug = route.paramMap.get('client');

  if (!slug) {
    router.navigate(['/page-not-found']);
    return false;
  }

  const storedClient = localStorage.getItem(slug);

  if (storedClient) {
    clientConfigService.setConfig(JSON.parse(storedClient));
    return true;
  }

  router.navigate(['/page-not-found']);
  return false;

  // return clientsService
  //   .getWebConfig({ name: slug! })
  //   .toPromise()
  //   .then((response) => {
  //     if (response) {
  //       return Promise.reject("Client not found");
  //     }

  //     clientConfigService.setConfig(response!);
  //     return true;
  //   })
  //   .catch((error) => {
  //     console.error("Error fetching client:", error);
  //     return Promise.reject("Error fetching client");
  //   });
};
